import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DateAdapter, MatDialogRef, MatSnackBar, MAT_DATE_FORMATS, MAT_DIALOG_DATA } from '@angular/material';
import moment from 'moment';
import Swal from 'sweetalert2';
import { AppDateAdapter, APP_DATE_FORMATS } from '../../../core/format-datepicker';
import { CreateAppointment } from '../../../core/model/v2/appointment/create-appointment';
import { AppointmentsService } from '../../../core/services/v2/appointments.service';
import { PracticeService } from '../../../core/services/v2/practice.service';
import { UtilsService } from '../../../core/services/v2/utils.service';
import { Practitioner } from '../../../physician/profile/models/practitioner';
import { PractitionerSetupBase } from '../../../physician/setup/profiles/Shared/PractitionerSetupBase';
import { PractitionersService } from '../../../practitioners/practitioners.service';
import { WindowLoaderService } from '../window-loader/window-loader.service';

@Component({
  selector: 'app-request-appointment-dialog',
  templateUrl: './request-appointment-dialog.component.html',
  styleUrls: ['./request-appointment-dialog.component.scss'],
  providers: [
    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS }]
})
export class RequestAppointmentDialogComponent implements OnInit {
  requestAppointmentForm: FormGroup;
  practitionerData: any;
  dateSelect: boolean = false;
  minDate: Date = new Date();
  healthSystems: any;
  treatments: any;
  allServices: any;
  services: any;
  YesNoArray = [
    { label: 'Yes', value: true },
    { label: 'No', value: false }
  ]
  isRequestAppointmentScreen: boolean = true;
  createAppointmentRequest: CreateAppointment;
  isTreatmentSelected: boolean;
  availableSlotsList: any;
  slotErrorMessage: string = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<RequestAppointmentDialogComponent>,
    private loaderService: WindowLoaderService,
    private appointmentsService: AppointmentsService,
    private practiceService: PracticeService,
    private fb: FormBuilder,
    private _util: UtilsService) {

  }

  ngOnInit() {
    this.practitionerData = this.data.professionalData;
    this.healthSystems = this.data.professionalData.healthSystems ? this.data.professionalData.healthSystems.filter(x => x.id > 1) : [];
    this.treatments = this.data.professionalData.practitionerTreatments;
    this.requestAppointmentForm = this.fb.group({
      patientId: [this.data.patientId, Validators.required],
      userId: [this.practitionerData.userId, Validators.required],
      practitionerId: [this.practitionerData.id, Validators.required],
      healthSystemId: ['', Validators.required],
      date: ['', Validators.required],
      requestedSlot: ['', Validators.required],
      spotSelected: [false, Validators.required],
      spotDate: ['', Validators.required],
      urgencyType: ['', Validators.required],
      anotherPractiotioner: [false, Validators.required],
      treatment: [null],
      service: [null],
      symptom: [null],
      symptomBeginDate: [null],
      symptomDetails: [null],
      isWorkRelatedInjury: [null],
      isMotorVehicleAccident: [false],
      isSymptomExistsEarlier: [null],
      isTestDone: [null],
      testResults: [null],
      seenAnyDoctorEarlier: [null],
      isVirtualVisit: [false]
    });
    this.clearSlotErrorMessage();
    this.loadServices()
  }

  loadServices() {
    const practitionerId = this.practitionerData.id;
    this.practiceService.getPractitionerServicesByPractitionerId(practitionerId).subscribe(
      (details) => {
        this.allServices = [];
        if (details && details.serviceData) {
          let data = details.serviceData;
          if (data) {
            let serviceData = JSON.parse(data);
            if (serviceData && serviceData.location) {
              this.allServices = serviceData.location;
            }
          }
        }
      },
      (error) => {
        console.error(error);
      }
    );

  }
  filterService() {
    this.services = [];
    if (this.allServices && this.allServices.length > 0) {
      const location = this.healthSystems.filter(x => x.id == this.requestAppointmentForm.get('healthSystemId').value);
      if (location && location.length > 0) {
        const locationId = location[0].location.id;
        let data = this.allServices.filter(x => x.locationId == locationId);
        let datanew = data.map(x => x.services);
        if (datanew) {
          this.services = [].concat(...datanew);
        }
      }
    }
  }


  onUrgencyChange(event: any) {
    if (event.target.value == 'Select Date') {
      this.dateSelect = true;
    }
    else {
      this.dateSelect = false;
    }
  }
  clearSlotErrorMessage() {
    this.slotErrorMessage = null;
  }

  onTreatmentChange(event: any) {
    this.isTreatmentSelected = true;
    this.requestAppointmentForm.controls.service.setValue(null);
  }
  onServiceChange(event: any) {
    this.isTreatmentSelected = false;
    this.requestAppointmentForm.controls.treatment.setValue(null);
  }

  continueAppointment() {
    let errorMessageList = [];
    if (this.requestAppointmentForm.controls.healthSystemId.invalid) {
      errorMessageList.push('Health System Location is mandatory.');
    }
    if (this.requestAppointmentForm.controls.urgencyType.invalid) {
      errorMessageList.push('Urgency selection is mandatory.');
    }
    if (this.requestAppointmentForm.controls.requestedSlot.invalid) {
      errorMessageList.push('Slot selection is mandatory.');
    }
    if (this.requestAppointmentForm.controls.urgencyType.value == 'Select Date') {
      if (!this.requestAppointmentForm.controls.date.value) {
        errorMessageList.push('Appointment Date is mandatory.');
      }
      if (!this.requestAppointmentForm.controls.spotDate.value || this.requestAppointmentForm.controls.spotDate.value == '') {
        errorMessageList.push('Slot Selection is mandatory.');
      }
      else if (!this.isDateValid(this.requestAppointmentForm.controls.spotDate.value)) {
        errorMessageList.push('Slot Selection is mandatory.');
      }
    }

    if (errorMessageList.length > 0) {
      this.requestAppointmentForm.markAllAsTouched();
      this._util.showMessageSnackBar(errorMessageList.join('\r\n'), true);
      return;
    }

    this.isRequestAppointmentScreen = false;
    this.filterService();
  }

  requestAppointment() {
    console.log(this.requestAppointmentForm);
    const res = this.validateAppointment();
    if (!res) {
      return;
    }
    let formData = this.requestAppointmentForm.getRawValue();

    let appointmentDate = this.getFormatedDate(new Date());
    if (formData.urgencyType == 'Select Date') {
      appointmentDate = formData.spotDate;
      formData.spotSelected = true;
    }
    else {
      formData.spotSelected = false;
    }
    let symptomStartDate = null;
    if (formData.symptomBeginDate) {
      symptomStartDate = this.getFormatedDate(formData.symptomBeginDate);
    }
    if (!this.isDateValid(appointmentDate)) {
      this._util.showMessageSnackBar("Appointment date is not selected. Please select appointment date first.", true);
      return;
    }

    let data: any = {
      patientId: formData.patientId,
      userId: formData.userId,
      date: appointmentDate,
      spotSelected: formData.spotSelected,
      symptom: formData.symptom,
      practitionerId: formData.practitionerId,
      fromPractitionerId: 0,
      healthSystemId: formData.healthSystemId,
      requestedSlot: formData.requestedSlot,
      isMotorVehicleAccident: formData.isMotorVehicleAccident,
      isWorkRelatedInjury: formData.isWorkRelatedInjury,
      isSymptomExistsEarlier: formData.isSymptomExistsEarlier,
      isTestDone: formData.isTestDone,
      seenAnyDoctorEarlier: formData.seenAnyDoctorEarlier,
      patientInsuranceId: 0,
      isVirtualVisit: formData.isVirtualVisit,
      symptomBeginDate: symptomStartDate,
      symptomDetails: formData.symptomDetails,
      testResults: formData.testResults,
      urgencyType: formData.urgencyType,
      treatment: formData.treatment,
      service: formData.service,
      anotherPractiotioner: formData.anotherPractiotioner
    }
    this.loaderService.blockWithLoader(this.appointmentsService.createAppointment(data)).subscribe(
      (data) => {
        if (data.response.isSuccess) {
          this.dialogRef.close({ success: true });
          //Swal.fire(
          //  'Request Appointment',
          //  `Your In-person appointment with Dr. ${this.practitionerData.fullName} has been requested successfully.`,
          //  'success'
          //)
        }
        else {
          this.dialogRef.close({ success: false });
          Swal.fire(
            'Sorry!',
            data.response.message,
            'error'
          )
        }
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      }
    );
  }

  getFreeAppointmentAllottedSlots() {
    this.clearSlotErrorMessage();
    const pratitionerId = this.practitionerData.id;
    const healthSystemId = this.requestAppointmentForm.controls.healthSystemId.value;
    const date = this.requestAppointmentForm.controls.date.value;
    if (!date) {
      this.slotErrorMessage = 'please select date first.';
      this.requestAppointmentForm.controls.requestedSlot.setValue('');
      return;
    }
    if (!healthSystemId) {
      this.slotErrorMessage = 'please select location first.';
      this.requestAppointmentForm.controls.requestedSlot.setValue('');
      return;
    }
    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    let exactDate = `${year}-${month}-${day}`;

    const period = this.requestAppointmentForm.controls.requestedSlot.value == 'Morning' ? 'AM' : 'PM';

    this.appointmentsService.GetFreeAppointmentAllottedSlots(pratitionerId, healthSystemId, exactDate, period).subscribe(
      (details) => {
        this.availableSlotsList = details.appointmentAllottedSlots;
        this.requestAppointmentForm.controls.spotDate.setValue('');
      },
      (error) => {
        console.error(error);
        this.loaderService.hide();
      }
    );

  }


  validateAppointment(): boolean {
    let errorMessageList = [];
    if (!this.requestAppointmentForm.controls.treatment.value && !this.requestAppointmentForm.controls.service.value) {
      errorMessageList.push('Please select either Treatment or Service.');
    }

    if (errorMessageList.length > 0) {
      this.requestAppointmentForm.markAllAsTouched();
      this._util.showMessageSnackBar(errorMessageList.join('\r\n'), true);
      return false;
    }

    return true;
  }

  private getFormatedDate(date: Date) {
    if (!date) {
      return null;
    }
    let day = ('0' + date.getDate()).slice(-2);
    let month = ('0' + (date.getMonth() + 1)).slice(-2);

    let year = date.getFullYear();

    return `${year}-${month}-${day}`;
  }


  cancel() {
    this.isRequestAppointmentScreen = true;
    this.dialogRef.close({ success: false });
  }

  isDateValid(dateStr: string) {
    return moment(dateStr).isValid();
  }

}
